import { isFeatureActive, useGetFarmFeatureFlags } from "utils";

import { FEATURE_FLAG_SLUGS } from "consts";

import { SOIL_PLUS_3_START_YEAR } from "pages/app/field-timeline/utils/PayoutUtils";

/**
 * The farm's field management payout comes from its Soil+ 3 allotment: both Soil+ 3 flags are on and the reporting year
 * has allotments. The rewards flag without the data gap flag is not a valid setup.
 */
export const useSoilPlus3Allotment = (
  farmId: string | undefined,
  reportingYear: number
): { usesAllotment: boolean; loading: boolean; unavailable: boolean } => {
  const { data: farmFeatureFlags, isLoading, isLoadingError } = useGetFarmFeatureFlags({ farmId: farmId ?? "" });
  const usesAllotment =
    isFeatureActive(FEATURE_FLAG_SLUGS.SOIL_PLUS_3_REWARDS, farmFeatureFlags) &&
    isFeatureActive(FEATURE_FLAG_SLUGS.SOIL_PLUS_3_DATA_GAP, farmFeatureFlags) &&
    reportingYear >= SOIL_PLUS_3_START_YEAR;

  // a failed first load must not quietly pick the regular payout rule for a Soil+ 3 farm; the flags poll every minute,
  // and a failed poll keeps the cached flags (isLoadingError is only set without data)
  return { usesAllotment, loading: isLoading, unavailable: isLoadingError };
};
